import { PublicClientApplication } from '@azure/msal-browser';
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import msalConfig from "../config/msalConfig";
import Main from "../views/Main.vue";
const routes: Array<RouteRecordRaw> = [


  {
    path: "/login",
    redirect: "/"
  },
  {
    path: "/",
    name: "Login",
    component: () => import("../views/Login/Login.vue"),
  },


  {
    path: '/main',
    name: 'main',
    component: Main,
    meta: { requiresAuth: true },
    redirect: { name: 'batchproduction' },
    children: [
      {
        path: "/home",
        name: "home",
        redirect: { name: 'dashboard' },
        children: [
          { path: "/dashboard", name: "dashboard", component: () => import(/* webpackChunkName: "about" */"../views/Dashboard/Dashboard.vue"), },
          { path: "/bateria", name: "bateria", component: () => import(/* webpackChunkName: "about" */"../views/Dashboard/Bateria.vue"), },
        ],
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Home.vue"),
      },

      {
        path: "/cadastroDump",
        name: "cadastroDump",
        redirect: { name: 'dump' },
        children: [
          { path: "/dump", name: "dump", component: () => import(/* webpackChunkName: "about" */ "../views/Cadastro/Dump/Dump.vue"), },
        ],
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Dump.vue"),
      },

      {
        path: "/cadastros",
        name: "cadastros",
        redirect: { name: 'batchproduction' },
        children: [

          { path: "/batchproduction", name: "batchproduction", component: () => import(/* webpackChunkName: "about" */ "../views/Cadastro/BatchProduction/BatchProduction.vue"), },
          { path: "/materials", name: "materials", component: () => import(/* webpackChunkName: "about" */ "../views/Cadastro/Materials/Materials.vue"), },
          { path: "/bombillofmaterials", name: "bombillofmaterials", component: () => import(/* webpackChunkName: "about" */"../views/Cadastro/BOM/BOM.vue"), },
          { path: "/device", name: "device", component: () => import(/* webpackChunkName: "about" */"../views/Cadastro/Device/Device.vue"), },
          { path: "/delivery", name: "delivery", component: () => import(/* webpackChunkName: "about" */"../views/Cadastro/Delivery/Delivery.vue"), },
          { path: "/exchange", name: "exchange", component: () => import(/* webpackChunkName: "about" */"../views/Cadastro/Exchange/Exchange.vue"), },
          { path: "/firmwareversion", name: "firmwareversion", component: () => import(/* webpackChunkName: "about" */"../views/Cadastro/Firmware/Firmware.vue"), },
          { path: "/hardwareversion", name: "hardwareversion", component: () => import(/* webpackChunkName: "about" */"../views/Cadastro/Hardware/Hardware.vue"), },
          { path: "/mechanicsversion", name: "mechanicsversion", component: () => import(/* webpackChunkName: "about" */"../views/Cadastro/Mechanics/Mechanics.vue"), },
          { path: "/messageversion", name: "messageversion", component: () => import(/* webpackChunkName: "about" */"../views/Cadastro/Message/Message.vue"), },
          { path: "/ocurrence", name: "ocurrence", component: () => import(/* webpackChunkName: "about" */"../views/Cadastro/Ocurrence/Ocurrence.vue"), },
          { path: "/estoque", name: "estoque", component: () => import(/* webpackChunkName: "about" */"../views/Cadastro/Estoque/Estoque.vue"),},
        ],
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Cadastros.vue"),
      },

      {
        path: "/version",
        name: "version",
        redirect: { name: 'firmwareversion' },
        children: [

          { path: "/firmwareversion", name: "firmwareversion", component: () => import(/* webpackChunkName: "about" */"../views/Cadastro/Firmware/Firmware.vue"), },
          { path: "/hardwareversion", name: "hardwareversion", component: () => import(/* webpackChunkName: "about" */"../views/Cadastro/Hardware/Hardware.vue"), },
          { path: "/mechanicsversion", name: "mechanicsversion", component: () => import(/* webpackChunkName: "about" */"../views/Cadastro/Mechanics/Mechanics.vue"), },
          { path: "/messageversion", name: "messageversion", component: () => import(/* webpackChunkName: "about" */"../views/Cadastro/Message/Message.vue"), },
        ],
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Version.vue"),
      },
      {
        path: "/production",
        name: "production",
        redirect: { name: 'batchproduction' },
        children: [

          { path: "/batchproduction", name: "batchproduction", component: () => import(/* webpackChunkName: "about" */ "../views/Cadastro/BatchProduction/BatchProduction.vue"), },
          { path: "/materials", name: "materials", component: () => import(/* webpackChunkName: "about" */ "../views/Cadastro/Materials/Materials.vue"), },
          { path: "/bombillofmaterials", name: "bombillofmaterials", component: () => import(/* webpackChunkName: "about" */"../views/Cadastro/BOM/BOM.vue"), },
        ],
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Production.vue"),
      },
      {
        path: "/operation",
        name: "operation",
        redirect: { name: 'device' },
        children: [
          { path: "/device", name: "device", component: () => import(/* webpackChunkName: "about" */"../views/Cadastro/Device/Device.vue"), },
          { path: "/delivery", name: "delivery", component: () => import(/* webpackChunkName: "about" */"../views/Cadastro/Delivery/Delivery.vue"), },
          { path: "/exchange", name: "exchange", component: () => import(/* webpackChunkName: "about" */"../views/Cadastro/Exchange/Exchange.vue"), },
          { path: "/ocurrence", name: "ocurrence", component: () => import(/* webpackChunkName: "about" */"../views/Cadastro/Ocurrence/Ocurrence.vue"), },
          { path: "/estoque", name: "estoque", component: () => import(/* webpackChunkName: "about" */"../views/Cadastro/Estoque/Estoque.vue"), },
        ],
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Operation.vue"),
      },
      {
        path: "/clientes",
        name: "clientes",
        redirect: { name: 'customer' },
        children: [
          { path: "/customer", name: "customer", component: () => import(/* webpackChunkName: "about" */"../views/Cadastro/Customer/Customer.vue"), },
        ],
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Clientes.vue"),
      },
      {
        path: "/trvdocs",
        name: "trvdocs",
        redirect: { name: 'trvdocsdevice' },
        children: [
          { path: "/trvdocsdevice", name: "trvdocsdevice", component: () => import(/* webpackChunkName: "about" */"../views/TrvDocs/TrvDocsDevice.vue"), },
        ],
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/TrvDocs/TrvDocs.vue"),
      },
      {
        path: "/exportsCSV",
        name: "exportsCSV",
        redirect: { name: 'trocadedendrometros' },
        children: [
          { path: "/trocadedendrometros", name: "trocadedendrometros", component: () => import(/* webpackChunkName: "about" */"../views/Exportacoes/TrocaDeDendrometros/TrocaDeDendrometros.vue"), }
        ],
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ExportsCSV.vue"),
      },
      {
        path: "/singletrees",
        name: "singletrees",
        redirect: { name: 'singletreesexportacao' },
        children: [
          { path: "/singletreesexportacao", name: "singletreesexportacao", component: () => import(/* webpackChunkName: "about" */"../views/SingleTrees/ExportacaoEstimativa.vue"), },
          { path: "/singletreesupload", name: "singletreesupload", component: () => import(/* webpackChunkName: "about" */"../views/SingleTrees/UploadInfoAmostra.vue"), },
          { path: "/singletreesreprocessamento", name: "singletreesreprocessamento", component: () => import(/* webpackChunkName: "about" */"../views/SingleTrees/Reprocessamento.vue"), },
          { path: "/singletreesdelecao", name: "singletreesdelecao", component: () => import(/* webpackChunkName: "about" */"../views/SingleTrees/DelecaoColetas.vue"), },
          { path: "/singletreesfila", name: "singletreesfila", component: () => import(/* webpackChunkName: "about" */"../views/SingleTrees/FilaJobs.vue"), },
        ],
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/SingleTrees/SingleTrees.vue"),
      },
      {
        path: "/viradaCadastro",
        name: "viradaCadastro",
        redirect: { name: 'ImportCsv' },
        children: [
          { path: "/ImportCsv", name: "ImportCsv", component: () => import(/* webpackChunkName: "about" */"../views/ViradaCadastro/ImportCsv.vue"), }
        ],
        // redirect: { name: "viradaCadastro" },
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ViradaCadastro/ViradaCadastro.vue"),

      },
    ],
  },





  // {
  //   path: "/dashboard",
  //   name: "dashboard",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/Dashboard.vue"),
  // },

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});


router.beforeEach((to, from, next) => {
  const $msalInstance = new PublicClientApplication(
    msalConfig

  );
  const contas = $msalInstance.getAllAccounts();
  if (to.path != '/login' && to.path != '/') {
    if (contas.length) {
      next();
    } else {
      next('login');
    }
  } else {
    next(); // This is where it should have been
  }

})
export default router;
